module.exports = __webpack_public_path__ + "static/media/pivots.f0a3dee4.jpg";